import type { Event } from "@apps/gwservice/types"

export type DayInfo = { mine: boolean; available: boolean }

export function buildDayMap(events: Event[]): Map<string, DayInfo> {
  const dayMap = new Map<string, DayInfo>()
  for (const event of events) {
    const key = event.date.toDateString()
    const value = dayMap.get(key) ?? { mine: false, available: false }
    dayMap.set(key, { mine: value.mine || event.attend === "go", available: value.available || event.attend !== "go" })
  }

  return dayMap
}
